import { render } from "./cartPage.vue?vue&type=template&id=1fee8970"
import script from "./cartPage.vue?vue&type=script&lang=js"
export * from "./cartPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__